import { render } from "./FormOwnershipView.vue?vue&type=template&id=41e72fa8"
import script from "./FormOwnershipView.vue?vue&type=script&lang=js"
export * from "./FormOwnershipView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__